module.exports = __webpack_public_path__ + "static/media/de_DE.06c3f4e4.png";